// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"f241b744","798":"d366ccad"}[chunkId] + ".chunk.js";
};